import {
  Activity,
  Award,
  Briefcase,
  Building2,
  Code2,
  Compass,
  Database,
  Eye,
  Flag,
  Gem,
  Globe,
  Hammer,
  Heart,
  Layers,
  Lightbulb,
  Map,
  Rocket,
  Server,
  ShieldCheck,
  Sparkles,
  Star,
  Target,
  Trophy,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

const REGISTRY: Record<string, LucideIcon> = {
  activity: Activity,
  award: Award,
  briefcase: Briefcase,
  building: Building2,
  building2: Building2,
  code: Code2,
  compass: Compass,
  database: Database,
  eye: Eye,
  flag: Flag,
  gem: Gem,
  globe: Globe,
  hammer: Hammer,
  heart: Heart,
  layers: Layers,
  lightbulb: Lightbulb,
  map: Map,
  mission: Target,
  philosophy: Compass,
  rocket: Rocket,
  server: Server,
  shield: ShieldCheck,
  'shield-check': ShieldCheck,
  sparkles: Sparkles,
  star: Star,
  target: Target,
  trophy: Trophy,
  users: Users,
  vision: Eye,
  wrench: Wrench,
  zap: Zap,
};

export function resolveIcon(key: string | undefined | null, fallback: LucideIcon = Sparkles): LucideIcon {
  if (!key) return fallback;
  const lookup = REGISTRY[key.toLowerCase()];
  return lookup || fallback;
}
